// FORGE Trailer — Sprecherstimme (Web Speech API, läuft komplett im Browser).
// Satzweise statt am Stück: natürlichere Pausen, und umgeht den ~15-Sekunden-
// Abbruch, mit dem Chrome/Edge lange Utterances mitten im Wort abschneiden.

// Tiefe MÄNNERSTIMME bevorzugen (Trailer-Voice); Frauenstimmen nur als letzter Fallback
const MALE = ['conrad', 'killian', 'florian', 'klaus', 'bernd', 'stefan', 'michael', 'andreas', 'jonas',
  'guy', 'christopher', 'ryan', 'eric', 'davis', 'andrew', 'brian', 'george', 'thomas'];
const FEMALE = ['katja', 'seraphina', 'amala', 'hedda', 'anna', 'elke', 'gisela', 'klarissa', 'louisa',
  'maja', 'tanja', 'vicki', 'marlene', 'petra', 'jenny', 'aria', 'michelle', 'sonia', 'libby', 'zira', 'ava', 'emma'];

// Aussprache-Korrekturen für die deutsche Stimme (englische Namen, Agenten-Kürzel)
const SAY_DE = [
  [/forge-factory\.app/gi, 'Fordsch-Factory Punkt App'],
  [/\bFORGE\b/g, 'Fordsch'],
  [/\bOSCAR\b/g, 'Oskar'],
  [/\bQUINN\b/g, 'Kwinn'],
  [/\bSTELLA\b/g, 'Stella'],
  [/\bTARA\b/g, 'Tara'],
  [/\bMAX\b/g, 'Max'],
  [/\bDEV\b/g, 'Deff'],
];

export function createNarrator(lang) {
  const synth = window.speechSynthesis || null;
  let voice = null, tune = { rate: 0.92, pitch: 0.8 };
  let queue = [], gen = 0, paused = false, keep = null, pending = null;
  let onChunk = null, onEnd = null;

  function rank(v) {
    const n = (v.name || '').toLowerCase();
    if (!v.lang || v.lang.toLowerCase().indexOf(lang) !== 0) return -1;
    let score = 100;
    // Neuronale Stimmen klingen deutlich natürlicher als die alten Desktop-Stimmen
    if (/natural|neural/.test(n)) score += 90;
    if (n.includes('online')) score += 8;
    MALE.forEach((m, i) => { if (n.includes(m)) score += 60 - i; });
    FEMALE.forEach(f => { if (n.includes(f)) score -= 80; });
    return score;
  }

  function pick() {
    if (!synth) return;
    const best = synth.getVoices().map(v => ({ v, s: rank(v) }))
      .filter(x => x.s >= 0).sort((a, b) => b.s - a.s)[0];
    if (!best) return;
    voice = best.v;
    // Neuronale Stimmen verzerren bei starkem Pitch-Shift — nur alte Stimmen tief ziehen
    const neural = /natural|neural/i.test(voice.name || '');
    tune = neural ? { rate: 0.94, pitch: 0.85 } : { rate: 0.90, pitch: 0.72 };
    if (pending) { const t = pending; pending = null; run(t); }
  }

  if (synth) {
    pick();
    // Stimmenliste kommt in Chrome/Edge asynchron nach
    if (synth.addEventListener) synth.addEventListener('voiceschanged', pick);
    else synth.onvoiceschanged = pick;
  }

  // Am Satzende und am Gedankenstrich trennen — das ergibt die Trailer-Pausen
  function chunks(text) {
    return (text.match(/[^.!?:…—]+[.!?:…—]*\s*/g) || [text])
      .map(s => s.replace(/\s*[—–]\s*$/, '').trim()).filter(Boolean);
  }

  function say(text) {
    if (lang !== 'de') return text;
    return SAY_DE.reduce((t, [re, to]) => t.replace(re, to), text);
  }

  // Chrome/Edge stoppen die Ausgabe nach ~15 s — pause()+resume() hält sie am Leben
  function keepalive(on) {
    if (!on) { clearInterval(keep); keep = null; return; }
    if (keep) return;
    keep = setInterval(() => {
      if (!synth || !synth.speaking || paused) return;
      synth.pause(); synth.resume();
    }, 9000);
  }

  function next(g) {
    if (g !== gen) return;
    const text = queue.shift();
    if (text === undefined) { keepalive(false); const f = onEnd; onEnd = null; if (f) f(); return; }
    const u = new SpeechSynthesisUtterance(text);
    u.voice = voice; u.lang = voice.lang;
    u.rate = tune.rate; u.pitch = tune.pitch; u.volume = 1;
    u.onstart = () => { if (g === gen && onChunk) onChunk(text); };
    u.onend = () => next(g);
    u.onerror = () => next(g);
    synth.speak(u);
    keepalive(true);
  }

  function run(text) {
    queue = chunks(say(text));
    next(gen);
  }

  function cancel() {
    gen++; queue = []; pending = null; onChunk = null; onEnd = null;
    keepalive(false);
    if (synth) synth.cancel();
  }

  return {
    // onLine(satz) läuft pro gesprochenem Satz (Untertitel), done() nach dem letzten
    speak(text, onLine, done) {
      cancel();
      if (!synth || !text) { if (done) done(); return; }
      onChunk = onLine; onEnd = done; paused = false;
      if (!voice) pick();
      if (!voice) {
        // Stimmen noch nicht geladen — kurz warten, sonst stumm weiterlaufen
        pending = text;
        setTimeout(() => { if (pending) { pending = null; const f = onEnd; onEnd = null; if (f) f(); } }, 2000);
        return;
      }
      run(text);
    },
    cancel,
    pause() { paused = true; if (synth) synth.pause(); },
    resume() { paused = false; if (synth) synth.resume(); },
  };
}
